import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {Dialogs} from '../dialogs.js';

import {oddsBoostsDialogFactory} from './odds-boosts-dialog.factory.js';

import PALETTE_SCHEMA from './odds-boosts-dialog.palette-schema.yaml';

class OddsBoostsDialogFeature extends AbstractVisualFeature {
    get name() {
        return 'OddsBoostsDialog';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return oddsBoostsDialogFactory(PALETTE);
    }
}

new OddsBoostsDialogFeature(Dialogs);
